import { URI } from '@/config/config'

export default async ({ rootState }, { body }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(body)
  }

  const userLoginInfoResult = await fetch(`${URI}vehicle/list-exempts`, opts)
  const resultJson = await userLoginInfoResult.json()
  return resultJson.result.exemptList
}